(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ahk-avant-commander"] && !Shopify.designMode) return;
  try {
    
  // Copy the size panel (note, chart, tips; not its heading) into every "Guide des tailles"
  // popup on the page, so the chart has one source: this section's blocks.
  (() => {
    const source = document.querySelector('.ahk-before__panel--sizes');
    if (!source) return;
    document.querySelectorAll('.product-popup-modal [data-ahk-size-guide]').forEach((target) => {
      const chart = document.createElement('div');
      chart.className = 'ahk-section ahk-size-modal';
      [...source.children].filter((el) => el.tagName !== 'H3').forEach((el) => chart.append(el.cloneNode(true)));
      chart.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
      target.querySelector('[data-ahk-size-fallback]')?.remove();
      target.querySelector('.ahk-size-modal')?.remove();
      target.append(chart);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-avis-defilants"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ahk-ticker-pause]');
    if (!button) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    button.closest('.ahk-ticker').toggleAttribute('data-paused', paused);
    button.querySelector('.ahk-visually-hidden').textContent = paused
      ? 'Reprendre le défilement des avis'
      : 'Mettre en pause le défilement des avis';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-avis"] && !Shopify.designMode) return;
  try {
    
  // From 750 px, re-deal the tiles for the column count shown, so photo and review alternate
  // along each row AND down each column: cell (row, col) holds a photo when row + col is even.
  // When one kind runs out, the other fills the remaining cells. Phones get the editor's order
  // back, for their masonry.
  const phone = window.matchMedia('(max-width: 749px)');
  const dealWall = (wall) => {
    const tiles = [...wall.children];
    if (phone.matches) {
      wall.dataset.cols = 'masonry';
      wall.append(...tiles.sort((a, b) => a.dataset.position - b.dataset.position));
      return;
    }
    const cols = getComputedStyle(wall).gridTemplateColumns.split(' ').length;
    if (wall.dataset.cols === String(cols)) return;
    wall.dataset.cols = cols;
    tiles.sort((a, b) => a.dataset.position - b.dataset.position);
    const queues = {
      photo: tiles.filter((tile) => tile.dataset.kind === 'photo'),
      review: tiles.filter((tile) => tile.dataset.kind === 'review'),
    };
    const order = tiles.map((_, cell) => {
      const want = (Math.floor(cell / cols) + (cell % cols)) % 2 === 0 ? 'photo' : 'review';
      const other = want === 'photo' ? 'review' : 'photo';
      return (queues[want].length ? queues[want] : queues[other]).shift();
    });
    wall.append(...order);
  };
  const dealAll = () => document.querySelectorAll('[data-ahk-wall]').forEach(dealWall);
  dealAll();
  phone.addEventListener('change', dealAll);
  window.matchMedia('(max-width: 989px)').addEventListener('change', dealAll);
  document.addEventListener('shopify:section:load', dealAll);

  // "Écrire un avis" on a product page: open the Judge.me form (unless it is already open)
  // through Judge.me's own button, then bring the form into view.
  const openReviewForm = () => {
    const reviews = document.querySelector('.ahk-avis-produit');
    if (!reviews) return;
    const link = reviews.querySelector('.jdgm-write-rev-link');
    const form = () => reviews.querySelector('.jdgm-form-wrapper');
    const isOpen = () => form() && getComputedStyle(form()).display !== 'none';
    // Judge.me's first click often only loads its form code and opens nothing; the next one
    // opens it. Click, give it 1.5s, and click again only while no form shows (3 tries).
    let clicks = 0;
    const open = () => {
      if (isOpen() || !link || clicks++ >= 3) return;
      link.click();
      setTimeout(open, 1500);
    };
    open();
    // Scroll once the form shows, or to the section if it never does.
    let tries = 0;
    const reveal = () => {
      if (isOpen() || tries++ > 50) {
        // Clear the sticky header, which would otherwise cover the top of the form.
        const target = isOpen() ? form() : reviews;
        const header = document.querySelector('.section-header');
        const offset = header && getComputedStyle(header).position === 'sticky' ? header.getBoundingClientRect().height : 0;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset - 20, behavior: 'smooth' });
        return;
      }
      setTimeout(reveal, 100);
    };
    reveal();
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-ahk-write-review]')) openReviewForm();
  });
  // Arriving from the list of pieces (#ecrire-un-avis): open the form once Judge.me has
  // rendered its button, which it does after the page has loaded.
  if ('ahkWriteReview' in document.documentElement.dataset) {
    let waited = 0;
    const whenReady = () => {
      // A beat more once the button shows, for Judge.me to bind its click handler.
      if (document.querySelector('.ahk-avis-produit .jdgm-write-rev-link')) return setTimeout(openReviewForm, 1000);
      if ((waited += 200) < 10000) setTimeout(whenReady, 200);
    };
    whenReady();
  }

  // Elsewhere: the list of pieces, in a modal dialog (closes on Esc, the cross or the backdrop).
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ahk-review-pick]');
    if (opener) return document.getElementById(opener.dataset.ahkReviewPick)?.showModal();
    const dialog = event.target.closest('.ahk-pick');
    if (dialog && (event.target === dialog || event.target.closest('[data-ahk-pick-close]'))) dialog.close();
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ahk-wall-expand]');
    if (!button) return;
    const wall = document.getElementById(button.getAttribute('aria-controls'));
    if (!wall) return;
    wall.removeAttribute('data-collapsed');
    button.setAttribute('aria-expanded', 'true');
    button.parentElement.hidden = true;
    // Keyboard users land on the first revealed tile, not back at the top of the page.
    const first = wall.children[8];
    if (first) {
      first.tabIndex = -1;
      first.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-buy-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ahk-buy-bar')) {
    customElements.define(
      'ahk-buy-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-buy]');
          this.price = this.querySelector('[data-price]');
          this.onClick = () => this.buy();
          this.button.addEventListener('click', this.onClick);
          // The theme editor re-renders the product section on every block edit:
          // rebuild against the new form instead of watching a detached one.
          this.onSectionLoad = () => this.init();
          document.addEventListener('shopify:section:load', this.onSectionLoad);
          this.init();
        }

        disconnectedCallback() {
          this.teardown();
          this.button?.removeEventListener('click', this.onClick);
          document.removeEventListener('shopify:section:load', this.onSectionLoad);
        }

        teardown() {
          this.formObserver?.disconnect();
          this.footerObserver?.disconnect();
          this.mutations?.disconnect();
        }

        init() {
          this.teardown();
          this.submit = document.querySelector('.product-form__submit');
          if (!this.submit) {
            this.hidden = true;
            return;
          }
          this.hidden = false;
          this.formAbove = false;
          this.footerInView = false;

          // Visible while the real button is ABOVE the viewport and the footer is not in view.
          // The button's root extends infinitely downward, so the only edge it can cross is
          // the top one: an instant jump from below to the top still fires. root: document
          // keeps rootMargin honoured inside the theme editor's cross-origin iframe.
          this.formObserver = new IntersectionObserver(
            ([entry]) => {
              this.formAbove = !entry.isIntersecting;
              this.update();
            },
            { root: document, rootMargin: '0px 0px 100000px 0px' }
          );
          this.formObserver.observe(this.submit);
          this.footerObserver = new IntersectionObserver(
            ([entry]) => {
              this.footerInView = entry.isIntersecting;
              this.update();
            },
            { root: document }
          );
          const footer = document.querySelector('.ahk-footer, .shopify-section-group-footer-group');
          if (footer) this.footerObserver.observe(footer);

          // Mirror price and availability: Dawn updates both in place on variant change.
          const info = this.submit.closest('product-info, .product__info-wrapper') || this.submit.parentElement;
          this.mutations = new MutationObserver(() => this.sync());
          this.mutations.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          this.sync();
          this.update();
        }

        sync() {
          const current =
            document.querySelector('.product .price--on-sale .price-item--sale') ||
            document.querySelector('.product .price__regular .price-item--regular');
          if (current) this.price.textContent = current.textContent.trim();
          // « Bientôt en rupture »: follows the badge Dawn re-renders in the price block, so a
          // sold-out variant hides it here too.
          const low = this.querySelector('[data-low]');
          if (low) {
            const onPage = !!document.querySelector('.product [id^="price-"] .ahk-low');
            low.innerHTML = onPage ? '<span class="ahk-low"><span class="ahk-low__dot" aria-hidden="true"></span>Bientôt en rupture</span>' : '';
          }
          // Euro line (eurozone visitors only): copy the one Dawn re-rendered with the price.
          const eur = this.querySelector('[data-eur]');
          if (eur) eur.innerHTML = document.querySelector('.product .price .ahk-eur')?.outerHTML || '';
          this.button.disabled = this.submit.disabled;
          this.button.textContent = this.submit.disabled ? this.submit.textContent.trim() : this.dataset.label;
        }

        buy() {
          if (!this.submit?.isConnected) this.init();
          if (!this.submit || this.submit.disabled) return;
          // Focus the real button first: Dawn returns focus there when the drawer closes,
          // and the bar hides once the form is back in view.
          this.submit.focus({ preventScroll: true });
          this.submit.click();
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.submit.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
        }

        update() {
          const show = this.formAbove && !this.footerInView;
          this.toggleAttribute('data-visible', show);
          this.inert = !show;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-concept"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ahk-concept-video')) {
    customElements.define(
      'ahk-concept-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.button = this.querySelector('[data-ahk-video-toggle]');
          if (!this.video || !this.button) return;
          this.button.addEventListener('click', () => (this.video.paused ? this.video.play() : this.video.pause()));
          this.video.addEventListener('play', () => this.render());
          this.video.addEventListener('pause', () => this.render());
          this.render();
        }

        render() {
          const paused = this.video.paused;
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.querySelector('[data-label]').textContent = paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-contact"] && !Shopify.designMode) return;
  try {
    
  // Shared by every .ahk-form (contact, partners): Shopify's bundle is site-wide.
  // After the post-and-reload, move focus to the success / error message; on error,
  // give back what was typed (Shopify only refills name, email and body itself).
  (() => {
    const KEY = 'ahk-form:';
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.ahk-form');
      if (!form) return;
      const values = {};
      form.querySelectorAll('input:not([type=hidden]), select, textarea').forEach((field) => { values[field.name] = field.value; });
      try { sessionStorage.setItem(KEY + form.id, JSON.stringify(values)); } catch (e) {}
    });

    const restore = () => {
      document.querySelectorAll('.ahk-form').forEach((form) => {
        const message = form.querySelector('[data-ahk-form-message]');
        const stored = sessionStorage.getItem(KEY + form.id);
        if (message?.classList.contains('ahk-form__error') && stored) {
          const values = JSON.parse(stored);
          form.querySelectorAll('input:not([type=hidden]), select, textarea').forEach((field) => {
            if (!field.value && values[field.name]) field.value = values[field.name];
          });
        }
        if (message) {
          message.focus({ preventScroll: false });
          if (message.classList.contains('ahk-form__success')) sessionStorage.removeItem(KEY + form.id);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
    else restore();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-ensembles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ahk-shop')) {
    customElements.define(
      'ahk-shop',
      class extends HTMLElement {
        // One delegated listener per connection, torn down on disconnect: the theme editor
        // re-connects the element when sections move, and state always comes from the DOM
        // (aria-pressed), so a reconnect can neither double the handlers nor desync them.
        connectedCallback() {
          this.controller = new AbortController();
          const { signal } = this.controller;
          this.addEventListener('click', (event) => this.onClick(event), { signal });
          document.addEventListener('click', (event) => this.onExternal(event), { signal });
          this.apply();
        }

        disconnectedCallback() {
          this.controller?.abort();
        }

        onClick(event) {
          const tab = event.target.closest('[data-tab-id]');
          const chip = event.target.closest('[data-collection]');
          const size = event.target.closest('[data-size]');
          if (tab) this.press('[data-tab-id]', tab);
          else if (chip) this.press('[data-collection]', chip);
          else if (size) {
            // Re-clicking the active size clears it.
            const active = size.getAttribute('aria-pressed') === 'true';
            this.press('[data-size]', active ? null : size);
          } else if (event.target.closest('[data-reset]')) {
            this.press('[data-size]', null);
            this.press('[data-collection]', this.querySelector('[data-collection=""]'));
          } else return;
          this.apply();
        }

        // Collection cards elsewhere on the page preselect a collection here. Modified
        // clicks (new tab, new window) and collections without a chip keep the real link.
        onExternal(event) {
          const link = event.target.closest('[data-ahk-filter]');
          if (!link || event.defaultPrevented || event.button !== 0) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const chip = [...this.querySelectorAll('[data-collection]')].find((c) => c.dataset.collection === link.dataset.ahkFilter);
          if (!chip) return;
          event.preventDefault();
          const firstTab = this.querySelector('[data-tab-id]');
          if (firstTab) this.press('[data-tab-id]', firstTab);
          this.press('[data-collection]', chip);
          this.apply();
          this.closest('section').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        press(selector, active) {
          this.querySelectorAll(selector).forEach((el) => el.setAttribute('aria-pressed', String(el === active)));
        }

        pressed(selector, key) {
          return this.querySelector(`${selector}[aria-pressed="true"]`)?.dataset[key] ?? '';
        }

        apply() {
          const typesOf = (tab) => (tab?.dataset.types || '').split(',').map((t) => t.trim()).filter(Boolean);
          const chip = this.querySelector('[data-collection][aria-pressed="true"]');
          const collection = chip?.dataset.collection || '';
          const exclude = chip?.dataset.exclude || '';
          const size = this.pressed('[data-size]', 'size');
          const cards = [...this.querySelectorAll('.ahk-card')];
          // Collection and size filters, without the type tab: shared by the grid and the tab counts.
          const base = (card) => {
            const cols = card.dataset.collections.split(' ');
            return (!collection || (cols.includes(collection) && !(exclude && cols.includes(exclude)))) &&
              (!size || card.dataset.sizes.split(' ').includes(size));
          };
          // Tabs with nothing to show under the current filters are hidden (a "Hauts 0" tab led
          // to an empty grid); if the pressed one goes, the first remaining tab takes over.
          const tabs = [...this.querySelectorAll('[data-tab-id]')];
          tabs.forEach((tab) => {
            const t = typesOf(tab);
            const count = cards.filter((card) => base(card) && (!t.length || t.includes(card.dataset.type))).length;
            const badge = tab.querySelector('[data-count]');
            if (badge) badge.textContent = count;
            tab.hidden = count === 0;
          });
          let activeTab = tabs.find((tab) => tab.getAttribute('aria-pressed') === 'true');
          if (activeTab?.hidden) {
            activeTab = tabs.find((tab) => !tab.hidden);
            if (activeTab) this.press('[data-tab-id]', activeTab);
          }
          const types = typesOf(activeTab);
          let shown = 0;
          cards.forEach((card) => {
            const ok = base(card) && (!types.length || types.includes(card.dataset.type));
            card.hidden = !ok;
            if (ok) shown += 1;
          });
          this.querySelector('.ahk-shop__empty').hidden = shown > 0;
          this.querySelector('[data-status]').textContent = `${shown} pièce${shown > 1 ? 's' : ''}`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ahk-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ahk-hero-swap')) {
    customElements.define(
      'ahk-hero-swap',
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = this.querySelectorAll('[data-set]');
          this.buttons.forEach((button) => button.addEventListener('click', () => this.set(button.dataset.set)));
          // Tapping the dimmed photo on desktop switches to it too.
          this.querySelectorAll('[data-photo]').forEach((photo) =>
            photo.addEventListener('click', () => this.set(photo.dataset.photo))
          );
        }

        set(state) {
          this.dataset.state = state;
          this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.set === state)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
